<template>
  <div class="rx-page">
    <div class="page-container">
      <!-- 面包屑 -->
      <nav class="breadcrumb">
        <a class="bc-link" @click.prevent="close">首页</a>
        <span class="bc-sep">/</span>
        <span class="bc-current">处方签</span>
      </nav>

      <!-- Hero -->
      <div class="hero-row">
        <div class="hero-left">
          <p class="hero-brand">关盈堂 · 处方服务</p>
          <h1 class="hero-title">处方签，一览清晰</h1>
          <p class="hero-subtitle">查看完整处方图片，按需预览、打印与了解配送。</p>
        </div>
        <button class="hero-back" type="button" @click="goBack">
          <span>返回我的服务</span>
          <span class="hero-back-arrow" aria-hidden="true">→</span>
        </button>
      </div>

      <!-- 提示条 -->
      <div class="notice-bar">
        <span class="notice-icon" aria-hidden="true">!</span>
        <p class="notice-text">处方图片仅供本人查看，请勿外传；处方内容及有效期以医生审核结果为准。</p>
      </div>

      <!-- 处方卡片 -->
      <div class="card-grid" v-if="prescriptions.length > 0">
        <div class="rx-card" v-for="(item, index) in prescriptions" :key="index">
          <p class="rx-eyebrow">PRESCRIPTION / {{ pad(index + 1) }}</p>
          <div class="rx-head">
            <h2 class="rx-name">{{ item.name }}</h2>
            <!-- <span class="rx-tag">{{ statusText(item) }}</span> -->
          </div>

          <div class="rx-preview" @click="openPreview(index)">
            <div :class="['print-div', 'img-print' + index]">
              <img :src="item.imageUrl" />
            </div>
          </div>
          <p class="rx-hint">点击查看大图</p>

          <div class="rx-actions">
            <button class="btn-ghost" type="button" @click="print(index)">打印预览</button>
            <!-- <button class="btn-primary" type="button" v-if="item.status == '0' || item.status == '1'"
              @click="fulfillment(index, item.name)">
              {{ shipText(item) }}
              <span class="btn-arrow" aria-hidden="true">→</span>
            </button> -->
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div class="rx-empty" v-else>
        <p>暂无处方图片</p>
      </div>

      <!-- 底部 -->
      <div class="page-bottom">
        <p class="bottom-hint">处方图片仅供本人查看，处方内容及有效期以医生审核结果为准。</p>
        <div class="bottom-actions">
          <button class="bottom-ghost" type="button" @click="close">关闭窗口</button>
          <button class="bottom-back" type="button" @click="goOrder">
            <span>查看订单</span>
            <span class="bottom-back-arrow" aria-hidden="true">→</span>
          </button>
        </div>
      </div>
    </div>

    <!-- 大图预览 -->
    <div class="preview-mask" v-if="previewVisible" @click="previewVisible = false">
      <img class="preview-img" :src="previewUrl" @click.stop />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      prescriptions: [],
      previewVisible: false,
      previewUrl: "",
    };
  },
  created() {
    var visitRecordId = this.$route.query.visitRecordId;
    var params = { visitRecordId: visitRecordId };
    // 读取 URL 中的可选筛选参数
    var recordType = this.$route.query.recordType;
    var prescriptionTypeLabel = this.$route.query.prescriptionType;
    if (recordType) params.recordType = recordType;
    if (prescriptionTypeLabel) params.prescriptionType = prescriptionTypeLabel;
    this.wjtHttp.get(
      this,
      `/api/health/v2/prescription/image/${visitRecordId}`,
      params,
      false,
      (res) => {
        var data = res.data;
        if (data.code == 200) {
          this.prescriptions = data.data;
        } else {
          this.$message({
            message:
              data.msg && data.msg.length > 0
                ? data.msg
                : "出方异常，请联系管理员",
            type: "error",
          });
        }
      },
      (err) => {
        console.log(err);
      }
    );
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    pad(n) {
      var s = String(n);
      return s.length < 2 ? "0" + s : s;
    },
    statusText(item) {
      if (!item) return "";
      return item.status == "1" ? "已配送" : "待配送";
    },
    shipText(item) {
      if (!item) return "申请配送";
      return item.status == "1" ? "配送详情" : "申请配送";
    },
    openPreview(index) {
      var item = this.prescriptions[index];
      if (!item || !item.imageUrl) return;
      this.previewUrl = item.imageUrl;
      this.previewVisible = true;
    },
    goOrder() {
      this.$router.push("/order");
    },
    close() {
      this.$router.replace("/");
    },
    print(index) {
      var newstr = document.getElementsByClassName("img-print" + index)[0]
        .innerHTML;
      console.log(newstr);
      document.body.innerHTML = newstr;
      // 打印前限制图片尺寸，保证一张处方签能放进一页 A4
      var printImgs = document.body.getElementsByTagName("img");
      for (var i = 0; i < printImgs.length; i++) {
        printImgs[i].style.width = "auto";
        printImgs[i].style.height = "auto";
        printImgs[i].style.maxWidth = "100%";
        printImgs[i].style.maxHeight = "96vh";
        printImgs[i].style.display = "block";
        printImgs[i].style.margin = "0 auto";
      }
      var oldstr = document.body.innerHTML;
      window.print();
      document.body.innerHTML = oldstr;
      window.location.reload();
    },
    fulfillment(index, name) {
      console.log(index, name);
      var prescription = this.prescriptions[index];
      if (prescription.status == 0) {
        var userInfo = this.$store.getters.getUserInfo;
        var roles = userInfo && userInfo.roles ? userInfo.roles : [];
        var isAgentDemo = false;
        for (var i = 0; i < roles.length; i++) {
          if (roles[i] == "level1" || roles[i] == "level2") {
            isAgentDemo = true;
            break;
          }
        }
        if (isAgentDemo) {
          this.$message.warning("当前为演示账号，配送下单功能暂未开放");
          return;
        }
        this.$confirm(
          `此患者共${this.prescriptions.length}有个处方，您正在确认配送${name}`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
        )
          .then(() => {
            sessionStorage.setItem(
              "prescription",
              JSON.stringify(prescription)
            );
            this.$store.commit("updateFulfillmentConfirmData", {});
            this.$router.push({
              path: "/fulfillmentConfirm",
              query: {
                index: index,
              },
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消配送",
            });
          });
      } else {
        this.$router.push({
          path: "/fulfillmentOrder",
          query: {
            orderId: prescription.deliveryOrderId,
          },
        });
      }
    },
  },
};
</script>

<style scoped>
/* ============================================================
   PrescriptionImage — 处方签（青绿主题 / 参考设计图）
   ============================================================ */
.rx-page {
  min-height: 60vh;
  background: #f5f7f2;
  color: #304744;
  padding-bottom: 20px;
}

.page-container {
  max-width: 1220px;
  margin: 0 auto;
  padding: 32px 24px 40px;
}

/* ========== 面包屑 ========== */
.breadcrumb {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  margin-bottom: 18px;
}

.bc-link {
  color: #527f77;
  cursor: pointer;
}

.bc-link:hover {
  color: #009798;
}

.bc-sep {
  color: #b6c6c1;
}

.bc-current {
  color: #304744;
  font-weight: 600;
}

/* ========== Hero ========== */
.hero-row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 22px;
}

.hero-brand {
  margin: 0 0 14px;
  font-size: 16px;
  font-weight: 600;
  color: #009798;
  letter-spacing: 1px;
}

.hero-title {
  margin: 0 0 12px;
  font-size: 40px;
  font-weight: 700;
  color: #304744;
  letter-spacing: 1px;
  line-height: 1.2;
}

.hero-subtitle {
  margin: 0;
  font-size: 17px;
  color: #527f77;
}

.hero-back {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 46px;
  padding: 0 22px;
  border: 1px solid #cfdcd8;
  border-radius: 12px;
  background: #fff;
  color: #304744;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.hero-back:hover {
  border-color: #009798;
  color: #009798;
}

.hero-back-arrow {
  color: #009798;
  font-weight: 700;
}

/* ========== 提示条 ========== */
.notice-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 22px;
  margin-bottom: 26px;
  border: 1px solid #f2e4c4;
  border-radius: 14px;
  background: #fdf7e9;
}

.notice-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1.5px solid #c9a24a;
  color: #c9a24a;
  font-size: 16px;
  font-weight: 700;
}

.notice-text {
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
  color: #8a6d3b;
}

/* ========== 卡片网格 ========== */
.card-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  align-items: start;
}

.rx-card {
  display: flex;
  flex-direction: column;
  padding: 26px 26px 24px;
  border: 1px solid #e9efec;
  border-radius: 22px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(23, 61, 59, 0.06);
  transition: all 0.2s ease;
}

.rx-card:hover {
  border-color: #b7ddd8;
  box-shadow: 0 16px 36px rgba(23, 61, 59, 0.1);
}

.rx-eyebrow {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #a9bcb6;
}

.rx-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}

.rx-name {
  margin: 0;
  font-size: 26px;
  font-weight: 700;
  color: #304744;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rx-tag {
  margin-left: auto;
  flex-shrink: 0;
  padding: 5px 14px;
  border-radius: 10px;
  background: #e6f4f1;
  color: #009798;
  font-size: 16px;
  font-weight: 600;
}

/* 图片预览 */
.rx-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 320px;
  padding: 14px;
  border: 1px solid #e9efec;
  border-radius: 14px;
  background: #f7faf9;
  overflow: hidden;
  cursor: pointer;
}

.rx-preview:hover {
  border-color: #b7ddd8;
}

/* 打印区域：内部必须是纯 img，打印时取该节点 innerHTML */
.print-div {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.print-div img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
}

.rx-hint {
  margin: 12px 0 0;
  text-align: center;
  font-size: 16px;
  color: #9aa8a3;
}

/* 卡内按钮 */
.rx-actions {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 20px;
}

.btn-ghost,
.btn-primary {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 48px;
  border-radius: 12px;
  font-family: inherit;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-ghost {
  border: 1px solid #cfdcd8;
  background: #fff;
  color: #304744;
}

.btn-ghost:hover {
  border-color: #009798;
  color: #009798;
}

.btn-primary {
  flex: 1.4;
  border: 1px solid #009798;
  background: #009798;
  color: #fff;
  box-shadow: 0 10px 22px rgba(0, 151, 152, 0.22);
}

.btn-primary:hover {
  background: #007e7f;
  border-color: #007e7f;
}

.btn-arrow {
  font-size: 16px;
}

/* ========== 空状态 ========== */
.rx-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  min-height: 260px;
  border: 1px dashed #dcebe7;
  border-radius: 18px;
  background: #fbfdfc;
  color: #9aa8a3;
}

.rx-empty i {
  font-size: 40px;
  color: #b7d9d5;
}

.rx-empty p {
  margin: 0;
  font-size: 17px;
  color: #9aa8a3;
}

.rx-empty .btn-ghost {
  flex: 0 0 auto;
  min-width: 160px;
  height: 44px;
}

/* ========== 底部 ========== */
.page-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 24px;
}

.bottom-hint {
  margin: 0;
  font-size: 16px;
  color: #9aa8a3;
}

.bottom-actions {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.bottom-ghost {
  height: 46px;
  padding: 0 22px;
  border: 1px solid #cfdcd8;
  border-radius: 12px;
  background: #fff;
  color: #527f77;
  font-family: inherit;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.bottom-ghost:hover {
  border-color: #009798;
  color: #009798;
}

.bottom-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 46px;
  padding: 0 22px;
  border: 1px solid #009798;
  border-radius: 12px;
  background: #fff;
  color: #009798;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.bottom-back:hover {
  background: #eaf6f4;
}

.bottom-back-arrow {
  font-weight: 700;
}

/* ========== 大图预览 ========== */
.preview-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: rgba(15, 32, 30, 0.72);
}

.preview-img {
  max-width: 92vw;
  max-height: 92vh;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
}

/* ========== 响应式 ========== */
@media (max-width: 1280px) {
  .card-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .page-container {
    padding: 20px 16px 32px;
  }

  .hero-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .hero-title {
    font-size: 28px;
  }

  .hero-back {
    width: 100%;
    justify-content: center;
  }

  .card-grid {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .rx-card {
    padding: 20px 18px;
    border-radius: 18px;
  }

  .rx-name {
    font-size: 22px;
  }

  .rx-preview {
    height: 260px;
  }

  .page-bottom {
    flex-direction: column;
    align-items: flex-start;
  }

  .bottom-actions {
    width: 100%;
  }

  .bottom-ghost,
  .bottom-back {
    flex: 1;
    justify-content: center;
  }
}
</style>

<style>
/* ===== 打印样式：保证处方图片能放进一页 A4 ===== */
@media print {
  @page {
    size: A4;
    margin: 8mm;
  }

  html,
  body {
    margin: 0 !important;
    padding: 0 !important;
    background: #fff !important;
  }

  img {
    max-width: 100% !important;
    max-height: 96vh !important;
    width: auto !important;
    height: auto !important;
    display: block !important;
    margin: 0 auto !important;
  }
}
</style>

